import { GetServerSideProps, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useState } from 'react'
import { LoggedOutContainer } from '@fe/common/components/LoggedOutContainer'
import { getUserLocale } from '@fe/common/src/utils/nextUtils'
import { EmailStep } from 'src/components/forgotPassword/EmailStep'
import { SuccessStep } from 'src/components/forgotPassword/SuccessStep'
import { LoggedOutLayout } from 'src/components/layouts/LoggedOutLayout'
import { withUnauthOnly } from 'src/utils/authUtils'

enum ForgotPasswordSteps {
  Email,
  Success,
}

const ForgotPassword: NextPage = () => {
  const { t } = useTranslation('no-auth')
  const [step, setStep] = useState(ForgotPasswordSteps.Email)

  const incrementStep = () => setStep(previous => previous + 1)

  const renderStep = () => {
    switch (step) {
      case ForgotPasswordSteps.Email:
        return <EmailStep incrementStep={incrementStep} />
      case ForgotPasswordSteps.Success:
        return <SuccessStep />
    }
  }

  return (
    <LoggedOutLayout title={t('forgot-password')}>
      <LoggedOutContainer heading={t('forgot-password')}>
        {renderStep()}
      </LoggedOutContainer>
    </LoggedOutLayout>
  )
}

export const getServerSideProps: GetServerSideProps = withUnauthOnly(
  async ({ req, locale, locales }) => {
    const userLocale = getUserLocale(req, locale, locales)

    return {
      props: {
        ...(await serverSideTranslations(userLocale, [
          'common',
          'no-auth',
          'errors',
        ])),
      },
    }
  }
)

export default ForgotPassword
